import Job from 'actions/job';

export default Job.createReducer();
